import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import Tooltip from "./Tooltip";
import { globalServices, itemServices } from "../../Services";
import { convertToDecimalString } from "../../Helpers/DecimalNumberHelper";
import ResultModal from "./ResultModal";
import {
  knToEuroConverter,
  euroToKnConverter,
} from "../../Helpers/CurrencyConverter";
import { currencyPriceList, currencyTagSessionName } from "../../Config/Consts";
const currencyTag = sessionStorage.getItem(currencyTagSessionName);
const AddProductModalCalculation = ({
  show,
  handleHide,
  tenantId,
  priceListId,
  addNewProduct,
  tenantTaxObligation,
}) => {
  const { t: translator } = useTranslation();
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [taxRates, setTaxRates] = useState([]);
  const [unitOfMeasures, setUnitOfMeasures] = useState([]);

  const [showNullTaxRate, setShowNullTaxRate] = useState(false);
  const [itemGroups, setItemGroups] = useState([]);
  const [item, setItem] = useState({
    isService: false,
    isRawMaterial: false,
    currencyTag: "EUR",
  });
  const [resultModal, setResultModal] = useState({
    show: false,
    title: "",
    text: "",
  });

  useEffect(() => {
    globalServices.getTaxRates().then((res) => setTaxRates(res.data));

    globalServices
      .getUnitOfMeasures()
      .then((res) => setUnitOfMeasures(res.data));

    globalServices.getItemGroups(tenantId).then((res) => {
      setItemGroups(res.data);
    });
  }, []);

  const checkPrice = () => {
    return document.getElementById("priceInput").value != "";
  };
  const checkPn = () => {
    var value = document.getElementById("pnInput").value;
    if (
      value === "" ||
      value === null ||
      value === "0,00" ||
      value === 0 ||
      value === "0,10" ||
      value == 0.1
    ) {
      return true;
    } else {
      return false;
    }
  };
  const currencyConverter = (currencyTag, value) => {
    return currencyTag === currencyPriceList.euro
      ? euroToKnConverter(value)
      : knToEuroConverter(value);
  };
  const checkTax = () => {
    return convertToDecimalString(document.getElementById("pp").value) >= 100
      ? false
      : true;
  };

  const handleIsServiceChange = (event) => {
    setItem({ ...item, isService: !item.isService });
  };
  const handleChangeRawMaterial = () => {
    if (item.isService) {
      setItem({
        ...item,
        isService: false,
        isRawMaterial: !item.isRawMaterial,
      });
    } else setItem({ ...item, isRawMaterial: !item.isRawMaterial });
  };

  const onSubmit = (data) => {
    itemServices
      .create({
        tenantId,
        createInAllPriceLists: true,
        priceListId: priceListId && Number(priceListId),
        name: data.name,
        code: data.code,
        barCode: data.barCode,
        description: data.description,
        isService: false,
        pn: parseFloat(convertToDecimalString(data.pnInput)),
        unitOfMeasureId: Number(data.unitOfMeasureId),
        taxRateId: Number(data.taxRateId) == -1 ? null : Number(data.taxRateId),
        itemGroupId: Number(data.itemGroupId) == -1 ? null : data.itemGroupId,
        price: parseFloat(convertToDecimalString(data.priceInput)),
        pp: Number(data.pp),
        isPriceLocked: false,
        currencyId: currencyPriceList[currencyTag],
        isRawMaterial: item.isRawMaterial ?? false,
        normativeTypeId:
          Number(data.normativeTypeId) == -1 ? 1 : data.normativeTypeId,
      })
      .then((res) => {
        if (res.data.success) {
          addNewProduct(
            res.data.data.itemId,
            res.data.data.name,
            res.data.data.price,
            res.data.data.taxRateValue ?? 0,
            res.data.data.isRawMaterial
          );
          handleHide();
          setResultModal({
            show: true,
            title: "Success",
            text: translator(res.data.message),
          });
        } else {
          handleHide();
          setResultModal({
            show: true,
            title: "Error",
            text: translator(res.data.message),
          });
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <Modal size="xl" show={show} onHide={handleHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>{translator("InitialState-AddProduct")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)} className="row">
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("EditItem-ArticleData")}
                </legend>
                <div className="form-group">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="isRawMaterial"
                      defaultChecked={item.isRawMaterial}
                      onChange={handleChangeRawMaterial}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>{translator("EditItem-RawMaterial")}</span>{" "}
                </div>
                <div className="form-group">
                  <label>{translator("EditItem-Name")}</label>{" "}
                  <Tooltip text={translator("Item-Name-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    ref={register({ required: true, maxLength: 100 })}
                    defaultValue={item.name}
                  />
                  {errors.name && errors.name.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.name && errors.name.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength100")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="ddlStore">
                    {translator("EditItem-ItemGroup")}
                  </label>
                  <select
                    name="itemGroupId"
                    ref={register({
                      validate: (value) => item.isRawMaterial || value !== "-1",
                    })}
                    className="form-control"
                  >
                    <option value="-1">{translator("EditItem-Choose")}</option>
                    {itemGroups &&
                      itemGroups.map((g) => (
                        <option
                          key={g.id}
                          selected={item.itemGroupId === g.id}
                          value={g.id}
                        >
                          {g.name}
                        </option>
                      ))}
                  </select>
                  {errors.itemGroupId &&
                    errors.itemGroupId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                </div>
                <div className="form-group">
                  <label htmlFor="ddlStore">
                    {translator("EditItem-UnitOfMeasure")}
                  </label>{" "}
                  <Tooltip text={translator("Item-UnitOfMeasure-Msg")} />
                  <select
                    name="unitOfMeasureId"
                    ref={register({
                      validate: (value) => value !== "-1",
                    })}
                    className="form-control"
                  >
                    <option value="-1">{translator("EditItem-Choose")}</option>
                    {unitOfMeasures &&
                      unitOfMeasures.map((x) => (
                        <option
                          selected={item.unitOfMeasureId === x.id}
                          value={x.id}
                          key={x.id}
                        >
                          {x.name}
                        </option>
                      ))}
                  </select>
                  {errors.unitOfMeasureId &&
                    errors.unitOfMeasureId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                </div>
                <div className="form-group">
                  <label htmlFor="ddlType">{translator("Tip proizvoda")}</label>{" "}
                  <Tooltip text={translator("Item-UnitOfMeasure-Msg")} />
                  <select
                    name="normativeTypeId"
                    ref={register({
                      validate: (value) => item.isRawMaterial || value !== "-1",
                    })}
                    className="form-control"
                    disabled={item.isRawMaterial}
                  >
                    <option value="-1">{translator("EditItem-Choose")}</option>

                    <option
                      selected={item.normativeTypeId === 1}
                      value={1}
                      key={1}
                    >
                      Proizvod
                    </option>
                  </select>
                  {errors.normativeTypeId &&
                    errors.normativeTypeId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                </div>
              </fieldset>
            </div>
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("EditItem-TaxInformation")}
                </legend>
                <div className="form-group">
                  <strong>
                    {" "}
                    <label>{translator("EditItem-Price")}</label>{" "}
                    <Tooltip text={translator("Item-Price-Msg")} />
                  </strong>
                  <div className="input-group">
                    <Controller
                      name="priceInput"
                      control={control}
                      rules={{
                        validate: (value) =>
                          item.isRawMaterial ? false : checkPrice,
                        maxLength: 14,
                      }}
                      as={
                        <NumberFormat
                          id="priceInput"
                          onValueChange={(e) => {
                            const value = e.floatValue;
                            setValue(
                              "priceInput2",
                              currencyConverter(item.currencyTag, value)
                            );
                          }}
                          thousandSeparator={" "}
                          allowNegative={false}
                          decimalSeparator={","}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          placeholder={"0,00"}
                          inputMode="numeric"
                          className="form-control"
                          disabled={Boolean(item.isRawMaterial)}
                        />
                      }
                      defaultValue={item.price}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        {item.currencyTag === currencyPriceList.euro
                          ? "€"
                          : "KN"}
                      </span>
                    </div>
                  </div>
                  {errors.priceInput &&
                    errors.priceInput.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  {errors.priceInput &&
                    errors.priceInput.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-PriceInput")}
                      </p>
                    )}
                </div>
                
                <div className="form-group">
                  <label htmlFor="ddlStore">
                    {translator("EditItem-TaxRate")}
                  </label>{" "}
                  <Tooltip text={translator("Item-TaxRate-Msg")} />
                  <select
                    ref={register}
                    name="taxRateId"
                    onChange={(e) => {
                      if (e.target.value == 0) {
                        setShowNullTaxRate(true);
                      } else {
                        setShowNullTaxRate(false);
                      }
                    }}
                    className="form-control"
                    disabled={
                      tenantTaxObligation == false ||
                      Boolean(item.isRawMaterial)
                    }
                  >
                    <option value="-1">{translator("EditItem-Choose")}</option>
                    <option value={0}>{translator("NullTaxRate")}</option>
                    {taxRates &&
                      taxRates.map((x) => (
                        <option selected={item.taxRateId === x.id} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                  </select>
                  {errors.taxRateId && errors.taxRateId.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                </div>

                <div className="form-group">
                  <label>{translator("EditItem-Refunds")}</label>{" "}
                  <Tooltip text={translator("Item-Refunds-Msg")} />
                  <div className="input-group">
                    <Controller
                      name="pnInput"
                      control={control}
                      rules={{
                        validate: (value) =>
                          item.isRawMaterial ? false : checkPn,
                      }}
                      as={
                        <NumberFormat
                          thousandSeparator={" "}
                          decimalSeparator={","}
                          fixedDecimalScale={true}
                          decimalScale={2}
                          placeholder={"0,00"}
                          inputMode="numeric"
                          className="form-control"
                          disabled={Boolean(item.isRawMaterial)}
                        />
                      }
                      defaultValue={item.pn}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        EUR
                      </span>
                    </div>
                  </div>
                  {errors.pnInput && errors.pnInput.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-PN")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("EditItem-ConsummationTax")}</label>{" "}
                  <Tooltip text={translator("Item-ConsummationTax-Msg")} />
                  <div className="input-group">
                    <input
                      type="number"
                      min="0"
                      step=".01"
                      className="form-control"
                      name="pp"
                      ref={register({
                        required: !Boolean(item.isRawMaterial),
                        min: 0,
                        max: 3,
                      })}
                      defaultValue={item.pp}
                      disabled={Boolean(item.isRawMaterial)}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text" id="basic-addon2">
                        %
                      </span>
                    </div>
                  </div>
                  {errors.pp && errors.pp.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.pp &&
                    (errors.pp.type === "min" || errors.pp.type === "max") && (
                      <p className="text-danger">
                        {translator("ValidationMsg-PP")}
                      </p>
                    )}
                </div>
              </fieldset>
            </div>
            <div className="col-lg-4">
              <fieldset className="scheduler-border">
                <legend className="scheduler-border">
                  {translator("EditItem-OtherData")}
                </legend>

                <div className="form-group">
                  <label>{translator("EditItem-Code")}</label>{" "}
                  <Tooltip text={translator("Item-Code-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="code"
                    defaultValue={item.code}
                    ref={register({
                      maxLength: 10,
                    })}
                  />
                  {errors.code && errors.code.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength10")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("EditItem-BarCode")}</label>{" "}
                  <Tooltip text={translator("Item-BarCode-Msg")} />
                  <input
                    type="text"
                    className="form-control"
                    name="barCode"
                    defaultValue={item.barCode}
                    ref={register({ maxLength: 15 })}
                  />
                  {errors.barCode && errors.barCode.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength15")}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>{translator("EditItem-Description")}</label>{" "}
                  <Tooltip text={translator("Item-Description-Msg")} />
                  <textarea
                    style={{ height: "128px" }}
                    id="textArea"
                    className="form-control"
                    name="description"
                    defaultValue={item.description}
                    ref={register({
                      maxLength: 250,
                    })}
                  />
                  {errors.description &&
                    errors.description.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength250")}
                      </p>
                    )}
                </div>
              </fieldset>
            </div>

            <div
              className="container-fluid"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              &nbsp;
              <button className="btn btn-primary" type="submit">
                {translator("Btn-Save")}
              </button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            data-dismiss="modal"
            onClick={handleHide}
          >
            {translator("Users-DeleteModal-Cancel")}
          </button>
        </Modal.Footer>
      </Modal>
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass="btn btn-outline-secondary"
        handleClose={() => setResultModal({ ...Controller, show: false })}
      />
    </>
  );
};

export default AddProductModalCalculation;
